import React from 'react';
import RelatedVideo from './RelatedVideo';
import Form from './Form';


let form =  {
    fields : [
        { label : "First Name",
            name : "firstName",
            type : "text",
            value : "",
            status : "initial",
            required : true,
            rules :null,
            pattern : /^[A-Za-z]/,
            errormsg :"First Name is required!"
        },
        {
            label : "Last Name",
            type : "text",
            name : "lastName",
            required:true,
            rules:null,
            value : "",
            status : "initial",
            pattern : /^[A-Za-z]/,
            errormsg:"Last Name is required!"
        },
        {
            label : "Email Address",
            name : "email",
            type : "email",
            required : true,
            rules : "email",
            status : "initial",
            value : "",
            pattern : /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
            errormsg :"Valid Email is required!"
        },
        {
            label : "Phone",
            name : "phone",
            type : "text",
            required :false,
            rules:null,
            status : "initial",
            value : "",
            //   pattern : /^(?=.*[0-9])[- +()0-9]+$/,
            pattern : /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/,
            //errormsg :"Valid Phone number is required!"
        },
        {
            label : "Comments",
            name : "maildesc",
            type : "textarea",
            required:false,
            rules:null,
            status : "initial",
            value : "",
            errormsg:"Comments is required!"
        }
    ]
};
let section_350_theatre_style = null;

class RelatedVideos extends React.Component{
    constructor(props){
        super(props);
        this.state = { cs : 0,  
            relatedVideos : [],
            showLoading : "block",
            containerWidth : 0,
            cardWidth : 0,
            cardsCount : 0,
            CardsPerPage : 0,
            noOfPages : 0,
            currentPage : 1,
            leftArrowStyle : "none",
            rightArrowStyle : "block",
            vidkey : this.props.vidkey
        };

        this.handleScrollLeft= this.handleScrollLeft.bind(this);
        this.handleScrollRight= this.handleScrollRight.bind(this);
        this.updateDimentions = this.updateDimentions.bind(this);
        this.loadVideos = this.loadVideos.bind(this);
        this.getQueryStringValue = this.getQueryStringValue.bind(this);
        this.handleClickVideo = this.handleClickVideo.bind(this);
    }

    getQueryStringValue = (key) => {  
        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
    };

    handleClickVideo(video, event){
        
        event.preventDefault();

        if(this.props.viPlayer === "1"){
            setTimeout(() => {
                document.querySelector('.video-object').classList.add('is_ece');
            }, 600);
        }
        document.querySelector('.video-object iframe').contentWindow.postMessage(JSON.stringify({ 'action':'aspect-ratio', value:'unset' }), "*");
        document.querySelector('.video-object iframe').src = '';
        document.querySelector('.video-object').setAttribute('style','aspect-ratio:16/9');
        let videoPoster = event.target;
        videoPoster.innerHTML = "";
        this.loadVideos(this.props.vidkey, video.video_fk, this.props.vehicleFkey);

            document.querySelector('.video-object iframe').style.visibility = 'hidden';
            setTimeout(function(){
                document.querySelector('.video-object iframe').style.visibility = 'visible';
            },600)
    }

    loadVideos(url, fkey, vehicle_fkey){

        if(this.state.url === url  && this.state.fkey === fkey) return false;
        const baseUrl = this.props.baseurl+"/LP/index_json.php";
        const urlParams = window.location.search;
        const endUrl = "&RUN_TYPE=LP_RELATED_VIDEOS_JSON";
        let relatedVideosUrl = baseUrl+urlParams+endUrl;
        const that = this;
        const xhttp = new XMLHttpRequest(); 
        
        if(this.props.preview){
            relatedVideosUrl = baseUrl+"?tmeplateId="+this.getQueryStringValue("tmeplateId")+"&template_domain_id="+this.getQueryStringValue("template_domain_id")+"&email="+this.getQueryStringValue("email")+"&user_id="+this.getQueryStringValue("user_id")+"&client_fk="+this.getQueryStringValue("client_fk")+endUrl;
        }else{
            url = url ? url : "";
            fkey = fkey ? fkey : "";
            vehicle_fkey = vehicle_fkey ? vehicle_fkey : "";

            relatedVideosUrl = baseUrl+"?e="+url+"&video_fkey="+fkey+"&vehicle_fkey="+vehicle_fkey+endUrl;    
            // relatedVideosUrl = "json/galaxy_rv.json";
        }  
        
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                let relatedVideosData = JSON.parse(this.responseText);                
              
                that.setState(relatedVideosData, function(){
                    that.updateDimentions();
                    that.setState({showLoading : "none"});
                  }); 

                that.setState({url : url, fkey : fkey});                   
            }
        };
        xhttp.open("GET", relatedVideosUrl, true);       
        xhttp.send();
    }

    componentDidMount(){
        
        /*let timeout = 2000;
        if(window.location.hostname === "ppmedia.flickfusion.net"){
            timeout = 4000;
        }
        setTimeout(() => {

            }, timeout);*/
        this.loadVideos(this.props.vidkey, this.props.video_fk, this.props.vehicleFkey);
        window.addEventListener("resize", this.updateDimentions);
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.loadVideos(nextProps.vidkey, nextProps.video_fk, nextProps.vehicleFkey);
    }

    updateDimentions(){
        let rvContainerWidth =  0;
        let cards =  0;
        let CardsPerPage =  0;
        let noOfPages =  0; 
        let cardsWidth = 0;
        let currentPage = 1;

        if(this.state.relatedVideos.length){
            const baseCardWidth = 285;   
            rvContainerWidth = document.getElementById('rv-container').offsetWidth;
            cards = document.getElementsByClassName("card");            
            
            if(cards.length){               
                CardsPerPage = Math.ceil(rvContainerWidth/baseCardWidth);
                cardsWidth = Math.ceil(rvContainerWidth/CardsPerPage);              
                
                if(rvContainerWidth <= 576){
                    CardsPerPage = 1;
                    cardsWidth = rvContainerWidth-15;
                    if(cardsWidth < 288){
                        cardsWidth = 288;
                    }
                }else if(rvContainerWidth > 576 && rvContainerWidth < 640){
                    CardsPerPage = 2;
                    cardsWidth = Math.floor((rvContainerWidth/2));
                }else if(rvContainerWidth > 640 && rvContainerWidth < 769){
                    CardsPerPage = 3;
                    cardsWidth = Math.floor((rvContainerWidth/3));
                }
                noOfPages = Math.ceil(cards.length/CardsPerPage); 
                //console.log(cards.length,"cardsperpage", CardsPerPage, "eachCard", cardsWidth, "rvContainerWidth", rvContainerWidth );
            }            
        }

        this.setState((prevState) => {
            if(prevState.containerWidth !== rvContainerWidth){                
                return {
                    containerWidth : rvContainerWidth, 
                    cardWidth : cardsWidth, 
                    cardsCount : cards.length,
                    cs : 0,
                    CardsPerPage:CardsPerPage,
                    noOfPages:noOfPages,
                    currentPage : currentPage,
                    leftArrowStyle : "none",
                    rightArrowStyle : "block"
                }
            }
        });    
    }

    handleScrollLeft(event){
        event.preventDefault();
        if(this.state.currentPage-1 === 1){
            this.setState({leftArrowStyle : "none", rightArrowStyle:"block"});
        }else{
            this.setState({leftArrowStyle : "block", rightArrowStyle:"block"});
        }
        if(this.state.currentPage === 1){            
            return false;
        }else if(this.state.currentPage > 1){            
            this.setState((prevState) => ({
                currentPage: prevState.currentPage - 1
            }));
            let transformValue = this.state.cs;
            let CardsPerPage = this.state.CardsPerPage;
            transformValue += CardsPerPage * this.state.cardWidth;
            this.setState( {cs : transformValue}); 
        }
    }

    handleScrollRight(event){ 

        event.preventDefault();
        if(this.state.currentPage+1 === this.state.noOfPages){
            this.setState({rightArrowStyle : "none", leftArrowStyle : "block"});
        }else{
            this.setState({rightArrowStyle : "block", leftArrowStyle : "block"}); 
        }

        if(this.state.currentPage === this.state.noOfPages){            
            return false;
        }else if(this.state.currentPage < this.state.noOfPages){           
            this.setState((prevState) => ({
                currentPage: prevState.currentPage + 1
            }));
            let transformValue = this.state.cs;
            let CardsPerPage = this.state.CardsPerPage;
            transformValue -= CardsPerPage * this.state.cardWidth
            this.setState( {cs : transformValue});  
        }
    }

    // truncateDesc = (txt) => {
    //     if(txt){
    //        return txt.length > 60 ? txt.slice(0,60)+"..." : txt;
    //     }
    // }

    render(){
       
        //let heading = null;
        let relatedVideosMarkup = null;  
        let classes = "container mt-3";
        let leftArrowStyle = null;
        let rightArrowStyle = null;
        
        const containerStyle = {
            position : "relative"
        }

        leftArrowStyle = {
            display: this.state.leftArrowStyle,
            top: (((this.state.cardWidth-15) * 0.56)/2)-25
        }

        rightArrowStyle = {
            display:this.state.rightArrowStyle,
            top: (((this.state.cardWidth-15) * 0.56)/2)-25
        }

        const videos = this.state.relatedVideos.map((video,index) => {
             return <RelatedVideo 
                    key={video.link+index}
                    handleLoadVideo={this.props.handleLoadVideo} 
                    handleClickVideo={this.handleClickVideo}
                    poster={video.poster} 
                    title={video.title} 
                    desc={video.short_desc} 
                    src={video.link} 
                    cs={this.state.cs} 
                    vfkey={video}  
                    width={this.state.cardWidth}
                    stockVin = {video.stock_vin}
                    template = {this.props.template}                   
                    backgroundImageVal={this.props.backgroundImageVal}
                />

         });

        let leftArrow = null;
        let rightArrow = null;

        if(this.state.noOfPages > 1){
             leftArrow = <div style={leftArrowStyle} className="left-arrow" onClick={this.handleScrollLeft}><i className="fa-solid fa-chevron-left"></i></div>;
             rightArrow = <div style={rightArrowStyle} className="right-arrow" onClick={this.handleScrollRight}><i className="fa-solid fa-chevron-right"></i></div>;
        }

        if(this.state.relatedVideos.length === 0){
            classes = "container";
            containerStyle.minHeight="0px";
        }

        if(this.props.template === "THEATER_CONTACT" || this.props.template === "THEATER_CONTACT_FOOTER" || this.props.template === "THEATER_360_FOOTER"){

            section_350_theatre_style = {
                marginBottom: '50px',
            }
        }

        if(this.props.template === "TABBED_THEATER" || this.props.template === "TABBED_THEATER_FOOTER"){
            containerStyle.maxWidth = "955px";
        }

        if(this.props.template === "THEATER_360_FOOTER"){

        //  containerStyle.maxWidth = "955px";
         relatedVideosMarkup =  
            <div className="wrapper_container">
                <section ref={this.rvWrapper} id="rv-container" style={containerStyle} className={classes}> 
                    <div style={{display : this.state.showLoading}} className="row">
                        <div className="col-sm-12 text-center">
                            <p>
                                <i className="fa-solid fa-circle-notch fa-spin fa-3x fa-fw"></i>
                                <span className="sr-only">Loading...</span>
                            </p>
                        </div>            
                    </div> 
                    <div className="row videos-wrapper">
                        {videos}
                    </div>
                        {leftArrow}
                        {rightArrow}

                    <div className="row">
                        <div className="col-sm-12" id="form-div" style={section_350_theatre_style}>
                            <Form frm={form}
                                lpForm={this.props.lpForm}
                                styles={this.props.styles}
                                shareurl={this.props.shareUrl}
                                dealerName={this.props.dealerName}
                                preview={this.props.preview}
                                disclaimer={this.props.disclaimer}
                                template = {this.props.template}
                                    backgroundImageVal={this.props.backgroundImageVal}
                            />
                        </div>
                    </div>
                </section>
                
                 
            </div>
         }else{

        relatedVideosMarkup =  
        <section ref={this.rvWrapper} id="rv-container" style={containerStyle} className={classes}> 
            <div style={{display : this.state.showLoading}} className="row">
                <div className="col-sm-12 text-center">
                    <p>
                        <i className="fa-solid fa-circle-notch fa-spin fa-3x fa-fw"></i>
                        <span className="sr-only">Loading...</span>
                    </p>
                </div>            
            </div> 
            <div className="row videos-wrapper">
                {videos}
            </div>
                {leftArrow}
                {rightArrow}
        </section>  
        }
        return relatedVideosMarkup;
    }
}
export default RelatedVideos;


// WEBPACK FOOTER //
// ./src/components/RelatedVideos.js